import React from 'react';

import Context from '../../../../../../context';

import {CustomBadges, CustomIcon, TableNullData} from '../../../../../../components';

import './index.sass';
import {locationNamespace} from "../../../../../../types/location.namespace";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import values from "../../../../../../values";

type Props = {
  data: any;
};

const Body: React.FC<Props> = ({ data }: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const userType = utils.stringHexConversion.reverse(Cookies.get(values.constants.USER.TYPE));
  const { setSelectedNeighborhood, setShowModal } = React.useContext(Context.Location.Neighborhood);
  const docs = data?.data?.result?.docs;

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickUpdate(neighborhood: locationNamespace.neighborhood.index): void {
    setSelectedNeighborhood!(neighborhood);
    setShowModal!('UPDATE');
  }

  function onClickDelete(neighborhood: locationNamespace.neighborhood.index): void {
    setSelectedNeighborhood!(neighborhood);
    setShowModal!('DELETE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <tbody id="location-neighborhood-body-wrapper">
      {docs?.map((neighborhood: locationNamespace.neighborhood.index, index: number) => (
        <tr key={`location-neighborhood-tr-${index}`}>
          <td className="table-text">{neighborhood.name}</td>
          <td className="table-text"><CustomBadges title={neighborhood.province?.name} /></td>
          <td className="table-text"><CustomBadges title={neighborhood.city?.name}     /></td>
          <td className="table-text"><CustomBadges title={neighborhood.town?.name}     /></td>
          <td className="table-options-wrapper">
            <CustomIcon icon={'fas fa-pencil'} type='primary' hoverTitle={'ویرایش'} onClick={() => onClickUpdate(neighborhood)} />
            { userType === 'ADMIN' && (
              <CustomIcon icon={'fas fa-trash-can-xmark'} type='danger' hoverTitle={'حذف'} onClick={() => onClickDelete(neighborhood)} />
            )}
          </td>
        </tr>
      ))}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Body;
